import { Alert, Button, Grid, Stack, Table } from "@mui/joy";
import axios from "axios";
import React, { useState } from "react";
import { useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { server_url } from "../core/config_geral";

function TrilhaBuilder() {

    const token = useSelector((state) => state.auth.token);

    const [state, setState] = useState({
        loading: true,
        error: null,
        trilhas: []
    })

    const atualizaDados = async () => {
        setState(prev => ({
            ...prev,
            loading: true,
            error: null,
            medias: []
        }));
        var formData = new FormData()
        var formToSend = {
            action: "CASTOR_RETORNA_LISTA_TRILHAS_RPC",
            runNow: true,
            payload: ""
        }

        formData.append("file", null)
        formData.append("data",
            new Blob([JSON.stringify(formToSend)], {
                type: "application/json"
            }))


        var r = await axios.post(server_url + "/rpc", formData, {
            headers: {
                'Content-Type': 'multipart/form-data',
                'Authorization': 'Bearer ' + token
            }
        }).then(response => response)
            .catch(error => error)

        if (r.status == 200) {
            console.log(r)
            setState(prev => ({
                ...prev,
                loading: false,
                error: null,
                trilhas: r.data.payload
            }));
        } else {
            setState(prev => ({
                ...prev,
                loading: false,
                error: "Não foi possível pegar todas as medias (Vide console)",
                trilhas: []
            }));
            console.log("error", r);
        }
    }

    React.useEffect(() => {
        atualizaDados();
    }, []);

    if (state.loading)
        return <Grid xs={12}>
            Loading...
        </Grid>

    return <>
        <Grid xs={12}>
            <Stack direction={"row"} spacing={1}>
                <Link to="/trilha-builder/nova">
                    <Button color="primary">Nova Trilha</Button>
                </Link>
                <Link onClick={atualizaDados}>
                    <Button color="danger">Atualizar</Button>
                </Link>
            </Stack>
        </Grid>
        {state.error !== null && <Grid xs={12} sx={{margin: "5px 0"}}><Alert color="danger"> {state.error}</Alert></Grid>}
        <Grid xs={12}>
            <Table size="sm" stripe={"odd"} >
                <thead>
                    <tr>
                        <td>Data</td>
                        <td>Título</td>
                        <td>Descricao</td>
                    </tr>
                </thead>
                <tbody>
                    {state.trilhas.map((m, index) => <tr key={index}>
                        <td>{m.createdAtFormatted}</td>
                        <td>{m.titulo}</td>
                        <td>{m.descricao}</td>
                        <td>
                            <Link>
                                Abrir
                            </Link>
                        </td>
                    </tr>)}
                </tbody>
            </Table>
        </Grid>
    </>
}

export default TrilhaBuilder;